import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  UpdateProposalPaymentScheduleInput,
  UpdateProposalPaymentScheduleMutation,
} from '@/gql/graphql';

const UPDATE_PROPOSAL_PAYMENT_SCHEDULE = graphql(`
  mutation UpdateProposalPaymentSchedule(
    $input: UpdateProposalPaymentScheduleInput!
  ) {
    updateProposalPaymentSchedule(input: $input) {
      id
      paymentSchedule {
        stages {
          description
          percentageDue
          isDeposit
        }
        explainer
      }
    }
  }
`);

const useUpdateProposalPaymentSchedule = (args?: {
  proposalPublicId?: string;
  options?: UseMutationOptions<
    UpdateProposalPaymentScheduleMutation,
    unknown,
    UpdateProposalPaymentScheduleInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: UpdateProposalPaymentScheduleInput) => {
      return gqlClient.request(UPDATE_PROPOSAL_PAYMENT_SCHEDULE, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      if (args?.proposalPublicId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalPublicId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateProposalPaymentSchedule;
